import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import { info, info1 } from '../../assets/images/rfidNfc/rfidNfcImages';

import S from './RfidNfc.module.css'
import BasicTable from '../../components/Table/BasicTable';

import { 
  infoNfcTagHeaderData, infoNfcTagBodytData, 
  infoTagHeaderData, infoTagBodyData, 
  infoMediumHeaderData, infoMediumBodyData, 
  infoFreqHeaderData, infoFreqBodyData } from './rfidNfcData';

const InfoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="rfid_nfc" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="rfid_nfc" />
        </div>
        <div className='com-content-wrap mb-50 mt-200'>
          <div style={{minHeight:'650px'}}>
            <div className={isMobile() ? '' : 'd-flex'}>
            {/* <div className='d-flex'> */}
              <div>
                <img src={info} className={isMobile() ? 'w-60 mt-40' : ''} />
              </div>
              <div id={S.infoIntroText}>
                RFID / NFC 는 무선주파수를 이용하여, 물건이나 사람 등과 같은 대상을 식별(Identification) <br />
                할 수 있도록 해주는 기술입니다. <br />
                RFID / NFC 는 안테나와 칩으로 구성된 태그에 정보를 저장하여 적용 대상에 부착 후, <br />
                RFID / NFC 리더를 통하여 정보를 인식하는 방법으로 활용되며 결제 뿐만 아니라, <br />
                출입통제, 물류, 유통 등 다양하게 활용되고 있습니다.
              </div>
            </div>
            <div>
              <img src={info1} className='mt-50' id={S.infoImg}/>
            </div>
  
            <div className='mt-20'>
              <div className={`${S.tableTitle} mt-30`}>NFC 태그 분류</div>
              <BasicTable headers={infoNfcTagHeaderData} items={infoNfcTagBodytData} />
            </div>
            <div className='mt-20'>
              <div className={`${S.tableTitle} mt-30`}>태그의 종류별 특징</div>
              <BasicTable headers={infoTagHeaderData} items={infoTagBodyData} />
            </div>
            <div className='mt-20'>
              <div className={`${S.tableTitle} mt-30`}>유사 매체별 특징</div>
              <BasicTable headers={infoMediumHeaderData} items={infoMediumBodyData} />
            </div>
            <div className='mt-20 mb-30'>
              <div className={`${S.tableTitle} mt-30`}>주파수 종류별 특징</div>
              <BasicTable headers={infoFreqHeaderData} items={infoFreqBodyData} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPage;
